import { AppImages } from 'app/appImages';
import { GenericAbortSignal } from 'axios';
import { AutoCompleteSuggestions, MprcAutoComplete } from 'components/MprcAutoComplete';
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { AutoCompleteDataModel, ChannelAutoCompleteDataModel } from 'components/MprcAutoComplete/AutoCompleteDataModel';
import React from 'react';

////////////////////////////////////////////////////////////////////////////

interface BaseChannelAutoCompleteProps extends Omit<IAutoCompleteProps, 'onGetSuggestions' | "emptyThumbnail" | "onChange" | "selectedItems"> {
    selectedItems: ChannelAutoCompleteDataModel[];
    onChange: (item: ChannelAutoCompleteDataModel[]) => void;
    onGetSuggestions: (data: ChannelAutoCompleteQueryParams, signal: GenericAbortSignal | undefined) => Promise<AutoCompleteSuggestions<ChannelAutoCompleteDataModel>>;
}

export type ChannelAutoCompleteQueryParams = {
    pageNumber: number;
    pageSize: number;
    searchText: string | null;
};

export interface ChannelAutoCompleteProps extends Omit<BaseChannelAutoCompleteProps, 'onGetSuggestions'> {
}


////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de canais
 * @param props
 */
export const BaseChannelAutoComplete: React.FC<BaseChannelAutoCompleteProps> = (props) => {

    const { selectedItems, onChange, onGetSuggestions } = props;

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<ChannelAutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();
        return onGetSuggestions({ pageNumber, pageSize, searchText }, signal);
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            onChange={(itens) => onChange(itens as ChannelAutoCompleteDataModel[])}
            selectedItems={selectedItems as AutoCompleteDataModel[]}
            emptyThumbnail={AppImages.KnowledgeChannelThumbnail}
            onGetSuggestions={getSuggestions}
        />
    );
};
